import React, {Fragment} from "react";
import { Switch, Route, Link } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import {useRecoilValue} from "recoil";
import MessagesNew from "./MessagesNew";
import SentMessages from "./SentMessages";
import DraftMessages from "./DraftMessages";
import { Globals } from "root/DataFunctions/BaseDataFns";
import useModalAddPost from "root/Modals/AddPost/useModalAddPost";
import {childDetailsState} from "root/recoil/childDetailsState";

import "../styles/Pages/messages.scss";
import {MessageType} from "root/DataFunctions/Constants";

const Messages = (props) => {
    const pathArray = props.location.pathname.split("/");
    const currentPageName = pathArray[pathArray.length - 1];
    const inboxMsgUrl = Globals.BaseURL + "/images/icons/child/email.png";
    const draftMsgUrl = Globals.BaseURL + "/images/icons/child/email-draft.png";
    const sentMsgUrl = Globals.BaseURL + "/images/icons/child/email-sent.png";
    const newIconUrl = Globals.BaseURL + "/images/icons/child/plus.png";

    const shouldShowToDropdown = true;

    const [renderAddMessagingModal, showAddMessagingModal] = useModalAddPost((result) =>
    {
        switch(result){
            case 'saved_create':
                props.history.push('/child/messages/sent');
                break;

            case 'saved_draft':
                props.history.push('/child/messages/draft');
                break;
        }
    })

    const handleCreateMessage = () => {
        //const child_uid = childDetails ? childDetails[0].adoptee_user_id : null;
        showAddMessagingModal('create', null, null, shouldShowToDropdown, MessageType.MESSAGE_TYPE_MESSAGE, null);
    }

    return (
        <Fragment>
            <div className="child-body-content">
                <div className="child-body-content-inner">
                    <div className="post-nav">
                        <div className="navigation">
                            <ul>
                                <li onClick={handleCreateMessage}>
                                    <Link to="#">
                                        <OverlayTrigger
                                            placement="right"
                                            overlay={ <Tooltip id="tooltip-right"> New Message </Tooltip> }
                                        >
                                        <span className="icon">
                                            <img className="img" src={newIconUrl} alt="Create message" />
                                        </span>
                                        </OverlayTrigger>
                                    </Link>
                                </li>
                                <li 
                                    className={currentPageName === "messages" || currentPageName === 'child' ? "list active" : "list"}
                                >
                                    <Link to="/child/messages">
                                        <OverlayTrigger
                                            placement="right"
                                            overlay={ <Tooltip id="tooltip-right"> Inbox </Tooltip> }
                                        >
                                        <span className="icon">
                                            <img className="img" src={inboxMsgUrl} alt="Inbox" />
                                        </span>
                                        </OverlayTrigger>
                                    </Link>
                                </li>
                                <li 
                                    className={currentPageName === "sent" ? "list active" : "list"}
                                >
                                    <Link to="/child/messages/sent">
                                        <OverlayTrigger
                                            placement="right"
                                            overlay={ <Tooltip id="tooltip-right"> Sent </Tooltip> }
                                        >
                                        <span className="icon">
                                            <img className="img" src={sentMsgUrl} alt="Sent" />
                                        </span>
                                        </OverlayTrigger>
                                    </Link>
                                </li>
                                <li 
                                    className={currentPageName === 'draft' ? "list active" : "list"}
                                >
                                    <Link to="/child/messages/draft">
                                        <OverlayTrigger
                                            placement="right"
                                            overlay={ <Tooltip id="tooltip-right"> Drafts </Tooltip> }
                                        >
                                        <span className="icon">
                                            <img className="img" src={draftMsgUrl} alt="Drafts" />
                                        </span>
                                        </OverlayTrigger>
                                    </Link>
                                </li>       
                            </ul>
                        </div>
                    </div>

                    <Switch>
                        <Route exact path="/child/messages/draft" component={DraftMessages} />
                        <Route exact path="/child/messages/sent" component={SentMessages} />
                        <Route exact path="/child/messages" component={MessagesNew} />
                        <Route exact path="/child/" component={MessagesNew} />
                    </Switch>
                </div>
            </div>

            {renderAddMessagingModal(props)}
        </Fragment>
    );
}

export default Messages;
